<template>
    <div
        id="qr-scanner"
        v-if="visible"
        v-bind="$attrs"
    >
        <div
            class="button button-rotate"
            @click="onRotate"
        >
            <img src="images/camera-switch-white.svg" />
        </div>

        <div
            class="button button-close"
            @click="stopScanning"
        >
            <i class="fa fa-times fa-2x"></i>
        </div>
    </div>
</template>

<script>
import { showErrorMessage } from '../dialogs';

export default {
    computed: {
        camera: {
            get() {
                return this.$store.getters[
                    'currentUser/getQrScannerCameraType'
                ](this.key);
            },
            set(value) {
                this.$store.commit(
                    'currentUser/setQrScannerCameraType',
                    { cameraKey: this.key, cameraType: value },
                    { root: true }
                );
            },
        },
    },
    data() {
        return {
            visible: false,
            key: null,
            singleScan: true,
            defaultCamera: 'back',
            mocker: null,
        };
    },
    methods: {
        startScanning() {
            if (!window.QRScanner) {
                if (this.mocker) {
                    return this.onScan(null, this.mocker(this.camera));
                }
                return showErrorMessage(
                    'Scanning wordt niet ondersteund op uw device'
                );
            }

            // Start scanner
            if (this.camera === 'back') {
                window.QRScanner.useBackCamera(() =>
                    window.QRScanner.scan(this.onScan)
                );
            } else {
                window.QRScanner.useFrontCamera(() =>
                    window.QRScanner.scan(this.onScan)
                );
            }

            // Hide UI
            document.body.style['background-color'] = 'transparent';
            document.body.children[0].style['background-color'] = 'transparent';
            document.getElementById('main-app').style['background-color'] =
                'transparent';
            document.getElementById('main-app').parentElement.style[
                'background-color'
            ] = 'transparent';
            document.getElementById('main-view').style.opacity = '0';

            // Show scanner
            window.QRScanner.show((status) => {
                //
            });
            this.visible = true;
        },
        stopScanning() {
            if (!window.QRScanner) {
                if (Config.production) {
                    showErrorMessage(
                        'Scanning wordt niet ondersteund op uw device'
                    );
                }
                return;
            }

            // Hide scanner
            this.visible = false;

            // Show UI
            document.getElementById('main-view').style.opacity = '1';
            document.getElementById('main-app').parentElement.style[
                'background-color'
            ] = '#f9f9f9';
            document.getElementById('main-app').style['background-color'] =
                '#f9f9f9';
            document.body.children[0].style['background-color'] = '#f9f9f9';
            document.body.style['background-color'] = '#f9f9f9';

            // Stop scanner
            window.QRScanner.destroy();
            this.$bus.$emit('qr_scanner.on_stop', this.key);
        },
        onScan(err, value) {
            // Handle errors
            if (err) {
                console.error('Scan error', err);
            }

            // On scan
            this.$bus.$emit('qr_scanner.on_scan', this.key, value);

            // Scan single
            if (this.singleScan) {
                this.stopScanning();
                return;
            }

            if (window.QRScanner) {
                // Add delay to prevent scanning same item again
                setTimeout(() => {
                    // Keep scanning
                    window.QRScanner.scan(this.onScan);
                    window.QRScanner.show((status) => {
                        //
                    });
                }, 1500);
            }
        },
        onRotate() {
            if (!window.QRScanner) {
                return;
            }

            if (this.camera === 'back') {
                window.QRScanner.useFrontCamera();
                this.camera = 'front';
            } else {
                window.QRScanner.useBackCamera();
                this.camera = 'back';
            }
        },
    },
    mounted() {
        // Start scanning
        this.$bus.$on('qr_scanner.start', (key, options) => {
            this.key = key;
            this.singleScan =
                options.singleScan !== undefined ? options.singleScan : true;
            if (!this.camera) {
                this.camera = options.defaultCamera
                    ? options.defaultCamera
                    : 'back';
            }
            this.mocker = options.mocker;
            this.startScanning();
        });

        // Stop scanning
        this.$bus.$on('qr_scanner.stop', (key) => {
            if (this.key === key) {
                this.stopScanning();
            }
        });
    },
};
</script>
